import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MyAvailabilityNewComponent } from './my-availability-new/my-availability-new.component';
import { TherapistMyProfileComponent } from 'src/app/therapist/my-profile/therapist-my-profile.component';
import { TherapistMyChangePasswordComponent } from 'src/app/therapist/my-change-password/therapist-my-change-password.component';
import { AuthenticationGuard } from '../shared/guards/authentication.guard';
import { TherapistRoleGuard } from '../shared/guards/therapist-role.guard';
import { WeekViewScheduler } from './my-appointments/week-view-scheduler/week-view-scheduler-component';

import { MyAppointmentsNewComponent } from './my-appointments-new/my-appointments-new.component';
import { WeekViewMobileComponent } from './week-view-mobile/week-view-mobile.component';

const therapistRoutes: Routes = [
  {
    path: 'my-appointments-new',
    canActivate: [AuthenticationGuard],
    component: MyAppointmentsNewComponent
  },
  {
    path: 'my-availability',
    canActivate: [AuthenticationGuard],
    component: MyAvailabilityNewComponent
  },
  {
    path: 'my-profile',
    canActivate: [AuthenticationGuard],
    component: TherapistMyProfileComponent
  },
  {
    path: 'change-password',
    canActivate: [AuthenticationGuard],
    component: TherapistMyChangePasswordComponent
  },
  {
    path: 'mobile-week-view',
    canActivate: [AuthenticationGuard],
    component: WeekViewMobileComponent
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'my-appointments-week',
    canActivate: [AuthenticationGuard],
    component: WeekViewScheduler
  }
];

const routes: Routes = [
  {
    path: '',
    canActivate: [TherapistRoleGuard],
    children: therapistRoutes
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TherapistRoutingModule {}
